import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { ValueAdapter } from '../value.adapter';
import { Model } from '../../backendmodel';
import { EventStreamLinkedService, type ITridentResource } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(EventStreamLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                artifactId: '*',
                workspaceId: '*'
            },
            parameters: '*'
        }
    }
})
export class EventStreamLinkedServiceAdapter extends LinkedServiceAdapter<EventStreamLinkedService> {

    protected override toAzureTypeProperties = (
        tridentResource: ITridentResource
    ): { artifactId: string; workspaceId: string } => ({
        artifactId: tridentResource.objectId,
        workspaceId: tridentResource.workspaceObjectId
    });

    protected modelConstructor(): new () => EventStreamLinkedService {
        return EventStreamLinkedService; 
    }

    protected model(): IModel {
        return EventStreamLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(
        linkedService: EventStreamLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource);
        properties.type = this.model().name;
        properties.typeProperties = {
            artifactId: this.valueToResource(linkedService, EventStreamLinkedService.ARTIFACT_ID),
            workspaceId: this.valueToResource(linkedService, EventStreamLinkedService.WORKSPACE_ID)
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(
        linkedServiceResource: Model.LinkedServiceResource,
        linkedService: EventStreamLinkedService
    ): Promise<EventStreamLinkedService> {
        const properties = linkedServiceResource.properties;
        const typeProperties = properties.typeProperties ?? {};
        ValueAdapter.toModel(linkedService, EventStreamLinkedService.ARTIFACT_ID, typeProperties.artifactId);
        ValueAdapter.toModel(linkedService, EventStreamLinkedService.WORKSPACE_ID, typeProperties.workspaceId);
        return linkedService;
    }
}